import { createReducer } from './../../service/Utils';

const initialState = {
  isShowFormCardDetail: false,
  cardDetailId: ''
};

export default createReducer(initialState, {
  SHOW_FORM_CARD_DETAIL: (state, payload = '') => {
    return {
      ...state,
      isShowFormCardDetail: !state.isShowFormCardDetail,
      cardDetailId: payload
    };
  }
});
